import { Button, Typography, useTheme } from '@mui/material'
import LoadingIcon from 'components/LoadingIcon'
import { useSensors } from 'hooks/useSensors'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { passwordResendEmail, resendEmail } from 'services/module/user'
import { FlexBox } from 'styleds'

export default function EmailConfirm({
  email,
  type = 'signUp',
  count,
}: {
  email: string
  type?: string
  count: number
}) {
  const [timerID, setTimerID] = useState<NodeJS.Timeout | null>(null)
  const { sensorsTrack } = useSensors()
  const [counter, setCounter] = useState(count)
  const [loading, setLoading] = useState<boolean>(false)
  const theme = useTheme()
  useEffect(() => {
    if (counter > 0) {
      const timer = setTimeout(() => {
        setCounter(counter - 1)
      }, 1000)
      setTimerID(timer)
    }
    return () => {
      setTimerID(null)
    }
  }, [counter])

  useEffect(() => {
    return () => {
      if (timerID) {
        clearTimeout(timerID)
      }
    }
  }, [timerID])

  const resend = () => {
    if (type === 'signUp') {
      sensorsTrack('GameRegisterVerifyPopClick', {
        module: 'resend',
        register_email: email,
        game_source: window.sessionStorage.getItem('source'),
      })
    }
    setLoading(true)
    const send = type === 'signUp' ? resendEmail : passwordResendEmail
    send(email).then(res => {
      if (res.code === 200) {
        toast.success(res.msg)
        setCounter(60)
        setLoading(false)
      } else {
        setLoading(false)
        toast.error(res.msg)
      }
    })
  }
  return (
    <>
      <Typography variant="h1" component="div">
        Verify your email
      </Typography>
      <FlexBox>
        <Typography variant="subtitle2" color={theme.colors.primary[100]} component="div">
          We have sent an email to
        </Typography>
      </FlexBox>
      <Typography variant="h6" color={theme.colors.white} component="div" marginTop={'4px'} marginBottom={'1.5rem'}>
        {email}
      </Typography>
      <Typography variant="subtitle2" color={theme.colors.primary[100]} component="div" marginBottom={'2.5rem'}>
        If you don&apos;t see any email, please check your spam folder.
      </Typography>
      <Typography variant="subtitle2" color={theme.colors.primary[400]} textAlign="center" component="div">
        Still can’t find the email?
      </Typography>
      <Button
        startIcon={loading ? <LoadingIcon theme="dark" /> : ''}
        color="primary"
        disabled={counter > 0}
        onClick={resend}
        variant="contained"
        fullWidth
        sx={{ marginTop: '1rem' }}
      >
        Resend Email {counter > 0 && `(${counter}s)`}
      </Button>
      {/* <Box sx={{ textAlign: 'center', marginTop: '1.5rem' }}>
        <Typography variant="body1" color="secondary" component="span">
          Need Help?
        </Typography>
        <Typography
          variant="subtitle2"
          onClick={() => {
            if (type === 'signUp') {
              sensorsTrack('GameRegisterVerifyPopClick', {
                module: 'help',
                game_source: window.sessionStorage.getItem('source'),
              })
            }
          }}
          sx={{ cursor: 'pointer', marginLeft: '4px' }}
          color={colors.blue[1]}
          component="span"
        >
          Contact Us
        </Typography>
      </Box> */}
    </>
  )
}
